import r from"./_baseAssignValue.js";import a from"./_baseForOwn.js";import e from"./_baseIteratee.js";var o=r,t=a,s=e;var n=function(r,a){var e={};return a=s(a),t(r,(function(r,t,s){o(e,t,a(r,t,s))})),e};export{n as default};
//# sourceMappingURL=mapValues.js.map
